module.exports = __webpack_public_path__ + "img/leaf-right.009d4ef4.png";